export default "__VITE_ASSET__Cypvg1wD__"